<template>
  <Technicals :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: 'IT架构与系统建模',
      content: '<div style="font-size:16px;text-indent:2em;">IT基础架构就像一个舞台，舞台布置好了，男女老少都可以在上面表演（信息化应用）。舞台包含了灯光、音响等。</div><br /><br /><div style="font-size:16px;text-indent:2em;padding-top:30px;">系统模型是一个系统某一方面本质属性的描述，它以某种确定的形式（如文字、符号、图表、实物、数学公式等）提供关于该系统的知识。系统建模的遵循原则是：1 切题；2 模型结构清晰；3 精度要求适当；4 尽量使用标准模型。</div><img src="../technical/5badf66db2592.jpg" style="width:500px;height:300px;margin:10px 100px;">'
    }
  }
}
</script>
